module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    staticClass: "box-set",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    }
  }, [_c('el-card', {
    attrs: {
      "header": "基础信息",
      "shadow": "naver"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动封面"
    }
  }, [_c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("\n        只能上传jpg/png文件，且不超过2M （建议尺寸：400px * 450px）\n      ")]), _vm._v(" "), _c('div', [_c('imgBox', {
    attrs: {
      "imgUrl": _vm.wximageurl + _vm.form.ad_pic,
      "inline": ""
    },
    on: {
      "click": _vm.handleImgChange
    }
  })], 1), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动名称",
      "prop": "activity_name",
      "rules": {
        required: true,
        message: '活动名称必填',
        trigger: 'blur'
      }
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 30,
      "placeholder": "活动名称"
    },
    model: {
      value: (_vm.form.activity_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "activity_name", $$v)
      },
      expression: "form.activity_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动时间"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "range-separator": "至",
      "start-placeholder": "生效时间",
      "end-placeholder": "过期时间",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "default-time": ['00:00:00', '23:59:59']
    },
    model: {
      value: (_vm.activity_date),
      callback: function($$v) {
        _vm.activity_date = $$v
      },
      expression: "activity_date"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动描述"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": ""
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.$set(_vm.form, "description", $$v)
      },
      expression: "form.description"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "每人累计限额",
      "prop": "limit_total_money",
      "rules": _vm.rules.limit_total_money
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 30,
      "placeholder": "每人累计限额"
    },
    model: {
      value: (_vm.form.limit_total_money),
      callback: function($$v) {
        _vm.$set(_vm.form, "limit_total_money", $$v)
      },
      expression: "form.limit_total_money"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "单笔最少限额",
      "prop": "limit_money",
      "rules": _vm.rules.limit_money
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 30,
      "placeholder": "每人单笔最少购买金额"
    },
    model: {
      value: (_vm.form.limit_money),
      callback: function($$v) {
        _vm.$set(_vm.form, "limit_money", $$v)
      },
      expression: "form.limit_money"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "header": "绑定商品",
      "shadow": "naver"
    }
  }, [_c('SkuSelector', {
    attrs: {
      "data": _vm.relItems
    },
    on: {
      "change": _vm.getItems
    }
  })], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "header": "设置商品",
      "shadow": "naver"
    }
  }, [(_vm.form.items.length > 0) ? _c('el-table', {
    staticStyle: {
      "line-height": "normal"
    },
    attrs: {
      "data": _vm.form.items
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "ID",
      "prop": "item_id",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品编号",
      "prop": "item_bn",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称",
      "prop": "item_title"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "类型",
      "prop": "special_type"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.special_type == 'drug') ? _c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("处方药")]) : _c('span', {
          staticStyle: {
            "color": "blue"
          }
        }, [_vm._v("非处方药")])]
      }
    }], null, false, 2651025645)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "活动价",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "width": "100",
            "min": "0.01",
            "onkeyup": "value=value.replace(/[^\\d{1,}\\.\\d{1,}|\\d{1,}]/g,'')"
          },
          model: {
            value: (scope.row.activity_price),
            callback: function($$v) {
              _vm.$set(scope.row, "activity_price", $$v)
            },
            expression: "scope.row.activity_price"
          }
        })]
      }
    }], null, false, 2729324909)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "每人限购",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "mini",
            "onkeyup": "this.value=this.value.replace(/\\D/g,'')"
          },
          model: {
            value: (scope.row.limit_num),
            callback: function($$v) {
              _vm.$set(scope.row, "limit_num", $$v)
            },
            expression: "scope.row.limit_num"
          }
        })]
      }
    }], null, false, 2760839821)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "库存",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "width": "90",
            "size": "mini"
          },
          model: {
            value: (scope.row.activity_store),
            callback: function($$v) {
              _vm.$set(scope.row, "activity_store", $$v)
            },
            expression: "scope.row.activity_store"
          }
        })]
      }
    }], null, false, 3447741873)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "排序",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "mini",
            "onkeyup": "this.value=this.value.replace(/\\D/g,'')"
          },
          model: {
            value: (scope.row.sort),
            callback: function($$v) {
              _vm.$set(scope.row, "sort", $$v)
            },
            expression: "scope.row.sort"
          }
        })]
      }
    }], null, false, 3858155467)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('i', {
          staticClass: "iconfont icon-trash-alt",
          on: {
            "click": function($event) {
              return _vm.deleteItemRow(scope.$index, _vm.form.items)
            }
          }
        }), _vm._v(" "), (scope.row.status == 'in_sale') ? _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.removeItemNow(scope.row, scope.$index, _vm.form.items)
            }
          }
        }, [_vm._v("剔除商品")]) : _vm._e()]
      }
    }], null, false, 1004640952)
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "header": "店铺",
      "shadow": "naver"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "适用店铺"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.shopTypeChange
    },
    model: {
      value: (_vm.form.use_all_shops),
      callback: function($$v) {
        _vm.$set(_vm.form, "use_all_shops", $$v)
      },
      expression: "form.use_all_shops"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "true"
    }
  }, [_vm._v("全部适用")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "false"
    }
  }, [_vm._v("指定店铺适用")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "以下店铺不可用"
    }
  }, [_c('el-checkbox-group', {
    on: {
      "change": _vm.choseDistributorNo
    },
    model: {
      value: (_vm.form.distributor_id_noflag),
      callback: function($$v) {
        _vm.$set(_vm.form, "distributor_id_noflag", $$v)
      },
      expression: "form.distributor_id_noflag"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "true"
    }
  }, [_vm._v("怡康自营选中店铺不可用")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "清空选中店铺"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.clearChoseDistributor()
      }
    }
  }, [_vm._v("清空选中店铺")])], 1), _vm._v(" "), (!_vm.zdShopHidden) ? _c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addDistributorAction
    }
  }, [_vm._v("选择店铺")]), _vm._v(" "), (_vm.distributor_info.length > 0) ? _c('el-table', {
    staticStyle: {
      "line-height": "normal"
    },
    attrs: {
      "data": _vm.distributor_info
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "ID",
      "prop": "distributor_id",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称",
      "prop": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "地址",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('i', {
          staticClass: "iconfont icon-trash-alt",
          on: {
            "click": function($event) {
              return _vm.deleteDistritutorRow(scope.$index, _vm.form.items)
            }
          }
        })]
      }
    }], null, false, 3521329561)
  })], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "content-center"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handleCancel.apply(null, arguments)
      }
    }
  }, [_vm._v("返回")]), _vm._v(" "), (this.copy_flag) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitActivityAction()
      }
    }
  }, [_vm._v("复制活动")]) : (_vm.form.status !== 'it_has_ended') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitActivityAction()
      }
    }
  }, [_vm._v("保存")]) : _vm._e()], 1), _vm._v(" "), _c('StoreSelect', {
    attrs: {
      "store-visible": _vm.storeVisible,
      "is-valid": true,
      "rel-shop-ids": _vm.relShopIds,
      "get-status": _vm.setStatus
    },
    on: {
      "chooseStore": _vm.chooseStoreAction,
      "closeStoreDialog": _vm.closeStoreDialogAction
    }
  }), _vm._v(" "), _c('DistributorSelect', {
    attrs: {
      "store-visible": _vm.distributorVisible,
      "is-valid": true,
      "rel-data-ids": _vm.distributor_info,
      "get-status": _vm.setDistributorStatus
    },
    on: {
      "chooseStore": _vm.chooseDistributorAction,
      "closeStoreDialog": _vm.closeDistributorDialogAction
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-62da4353", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62da4353"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/promotions/limitedtimesale/add.vue
// module id = 2777
// module chunks = 0